export enum ModalSize {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
  Responsive = 'Responsive',
}
